import React                     from 'react';
import { PulseLoadingIndicator } from '../../PulseLoadingIndicator';
import { LoadingScreenRoot }     from './styles';

export function LoadingScreen() {
    return <LoadingScreenRoot><PulseLoadingIndicator /></LoadingScreenRoot>;
}
